import mtasks from "./img/mtasks.png"
import numeri from "./img/numeri.png"
import  gapp from "./img/g_app.png"
import res from "./img/res.png"
import restart from "./img/Screenshot 2024-12-15 at 18.22.22.png"
import crypto1 from "./img/crypto1.png"
export const Workitems = [
    {
        id: 1,
        status: "2024",
        title: "Task Managemant App",
        imgSrc: mtasks,
        siteLink: "https://mtasks.netlify.app/",
        techs: ["React Js", "Ant DS", "Firebase Service", "Redux"]
    },
    {
        id: 2,
        status: "2024",
        title: "Numeri E-Commerce",
        imgSrc: numeri,
        siteLink: "https://numerishop.netlify.app/",
        techs: ["React Js", "Ant DS", "Firebase Service", "Redux"]
    },
    {
        id: 3,
        status: "2024 Nov",
        title: "Who Wants to be Millionare Game",
        imgSrc: "https://m.media-amazon.com/images/I/71wZi-+gTRL.jpg",
        siteLink: "https://milionaregame.netlify.app/login",
        techs: ["React Js", "Ant DS", "Firebase Service", "Redux"]
    },
    {
        id: 4,
        status: "AI Project",
        title: "KH Image Generator App - AI Integration",
        imgSrc: gapp,
        siteLink: "https://te2image.netlify.app/",
        techs: ["React Js", "Ant DS", "Supabase Back", "EmailJS", "Huggingface API"]
    },
    {
        id: 5,
        status: "2024 Yerevan",
        title: "Resume Builder",
        imgSrc: res,
        siteLink: "https://khresbuilder.netlify.app/",
        techs: ["React Js", "Ant DS", "Firebase Back"]
    },
    {
        id: 6,
        status: "Informative",
        title: "Restart Service Website",
        imgSrc: restart,
        siteLink: "https://restartservice.netlify.app/",
        techs: ["TypeScript", "Ant DS", "Supabase"]
    },
    {
        id: 7,
        status: "Next.js",
        title: "CryptoNova Marketplace",
        imgSrc: crypto1,
        siteLink: "https://cryptonova-tau.vercel.app/",
        techs: ["Next.js", "TypeScript", "Tailwand CSS", "Supabase", "Clerk", "MobX", "Trigger.dev"]
    },
]
